export const config: AppConfig = window.__CONFIG__;
